import axios from '@/core/axios';
import { UserTimer } from './user-timers.types';

export class UserTimersService {
  create(user_timer: UserTimer): Promise<UserTimer[]> {
    return axios.post<UserTimer[]>(`/user-timer`, user_timer).then(resp => resp?.data);
  }
}

export const userTimersService = new UserTimersService();
